import type { CleaningTaskQueueResponse } from '@/shared/api';
import {
  cleaningDayCounts,
  filterCleaningDay,
  type CleaningDayFilter,
} from '../day/cleaningDayModel';

export type CleaningBoardView = 'list' | 'calendar';

export const BOARD_FILTERS: { value: CleaningDayFilter; label: string }[] = [
  { value: 'all', label: 'Alle' },
  { value: 'free', label: 'Frei' },
  { value: 'active', label: 'In Reinigung' },
  { value: 'overdue', label: 'Überfällig' },
  { value: 'completed', label: 'Erledigt' },
];

/**
 * Die Lage des Tages als ein Satz unter dem Titel („2 frei · 3 Anreisen heute · …“). Ohne geladene
 * Liste steht nur das Datum da – keine Null, die niemand gezählt hat.
 */
export function boardFacts(
  tasks: CleaningTaskQueueResponse[] | undefined,
  date: string,
  isToday: boolean,
): string | null {
  if (!tasks) return null;
  const counts = cleaningDayCounts(tasks, date);
  return [
    `${counts.free} frei`,
    `${counts.arrivals} ${counts.arrivals === 1 ? 'Anreise' : 'Anreisen'}${isToday ? ' heute' : ''}`,
    `${counts.overdue} überfällig`,
    `${counts.completed} erledigt`,
  ].join(' · ');
}

/** Zahl je Statusreiter aus der vollständig geladenen Tagesliste; ohne Liste keine Zahl. */
export function filterCount(
  tasks: CleaningTaskQueueResponse[] | undefined,
  filter: CleaningDayFilter,
): number | undefined {
  return tasks ? filterCleaningDay(tasks, filter).length : undefined;
}
